import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import { Component, Inject, Mixins, Watch } from "vue-property-decorator";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";

import { namespace } from "vuex-class";
import { EServices } from "@/types";
import { ICurrency, ITransaction, ITransactionPageInfo } from "../../types";
import { currencyImages, statusClassNames } from "../../constants";
import { datetime } from "@/utils/time";
import VScrollView from "@/vuetify-extensions/VScrollView.vue";
import VEmptyState from "@/vuetify-extensions/VEmptyState.vue";
import NetworkErrorImage from "@/components/NetworkErrorImage.vue";
import TransactionsClient from "../../services/TransactionsClient";

const TransactionsModule = namespace("TransactionsModule");

@Component({
  components: {
    VScrollView,
    VEmptyState,
    NetworkErrorImage,
  },
})
export default class Transactions extends Mixins(
  JackocoinsNetworkManagerMixin
) {
  transactionSummaries: any[] = [];
  selectedCurrency: ICurrency | null = null;
  transactionSummaryVisible = false;
  selectedSort = "all";
  sorts = ["all", "pool", "pending", "approved", "reported"];
  refresh = false;

  @TransactionsModule.State
  currencies!: ICurrency[];

  @TransactionsModule.State
  transactions!: ITransaction[];

  @TransactionsModule.State
  transactionPageInfo!: ITransactionPageInfo;

  @Inject(EServices.transactions)
  transactionsClient!: TransactionsClient;

  get parsedCurrencies() {
    const currenciesSet = new Set(this.currencies.map((c) => c.symbol));
    const currencies: any[] = [];
    for (const c of currenciesSet) {
      const currency = this.currencies.find((curr) => curr.symbol == c);
      currencies.push({
        ...currency,
        image: require(`@/assets/images/icons/currencies/${currency!.symbol.toLowerCase()}.svg`),
      });
    }
    return currencies;
  }

  getStatusBarWidth(
    status: "pool" | "pending" | "approved" | "reported"
  ): number {
    switch (status) {
      case "pool":
        return 25;
      case "pending":
        return 50;
      case "approved":
        return 100;
      case "reported":
        return 100;
      default:
        return 0;
    }
  }

  sortTransactionRule(transaction: ITransaction) {
    if (this.selectedSort == "all") return true;
    else if (transaction.status == this.selectedSort) return true;
    return false;
  }

  datetime = datetime;

  toggleTransactionSummary() {
    this.transactionSummaryVisible = !this.transactionSummaryVisible;
  }

  @throwsNetworkError()
  async getCurrencies() {
    await this.transactionsClient.getAllCurrencies();
    this.selectedCurrency = this.parsedCurrencies[0];
  }

  @throwsNetworkError()
  async getTransactions(page: number = 1, size: number = 20) {
    const response = await this.transactionsClient.fetchTransactions(
      this.selectedCurrency!,
      page,
      size
    );
    return response;
  }

  async getTransactionsBound(...args: any[]) {
    return await this.getTransactions(...args);
  }

  getStatusClassName(status: string): string {
    return "lighten-5 " + statusClassNames[status];
  }

  @Watch("selectedCurrency")
  onSelectedCurrencyChange() {
    this.refresh = true;
  }

  mounted() {
    this.getCurrencies();
    this.getTransactions();
    this.transactionSummaries = [
      {
        icon: "mdi-account-convert",
        text: "Total runs",
        value: this.transactionPageInfo.totalTrades,
      },
      {
        icon: "mdi-shopping",
        text: "My bag",
        value:
          this.transactionPageInfo.totalNgn && this.transactionPageInfo.totalNgn
            ? `₦${parseFloat(
                this.transactionPageInfo.totalNgn.toFixed(2)
              ).toLocaleString()} ($${parseFloat(
                this.transactionPageInfo.totalUsd.toFixed(2)
              ).toLocaleString()})`
            : "0",
      },
      { icon: "mdi-credit-card-multiple", text: "Lump", value: "$0" },
    ];
    // this.getTransactions();
  }
}
